/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as errors from "../../../../errors/index";
export class ForbiddenError extends errors.FlatfileError {
    constructor(body, rawResponse) {
        super({
            message: "ForbiddenError",
            statusCode: 403,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, ForbiddenError.prototype);
    }
}
